import { Link } from 'react-router-dom';
import { liveEvents } from '@/mocks/common';

export default function LiveEventsSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              实时赛事
              <span className="inline-flex items-center ml-3">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
                </span>
                <span className="ml-2 text-sm font-normal text-red-500 font-sans">LIVE</span>
              </span>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时比分 · 即时赔率 · 滚球投注</p>
          </div>
          <Link to="/category/football" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
            查看全部赛事 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {liveEvents.slice(0, 6).map((event) => (
            <Link
              key={event.id}
              to={`/category/${event.category}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full">
                  {event.league}
                </span>
                <span className="flex items-center gap-1 text-xs text-red-500 font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"></span>
                  {event.time}
                </span>
              </div>

              <div className="flex items-center justify-between mb-4">
                <div className="flex-1">
                  <p className="text-sm font-semibold text-foreground-900">{event.homeTeam}</p>
                  <p className="text-sm font-semibold text-foreground-900 mt-1">{event.awayTeam}</p>
                </div>
                <div className="text-center px-3">
                  <div className="text-xl font-heading font-bold text-foreground-950">{event.homeScore}</div>
                  <div className="text-xs text-foreground-400 my-0.5">-</div>
                  <div className="text-xl font-heading font-bold text-foreground-950">{event.awayScore}</div>
                </div>
              </div>

              <div className="flex gap-2">
                {event.drawOdds > 0 ? (
                  <>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">主胜</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.homeOdds}</span>
                    </div>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">平</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.drawOdds}</span>
                    </div>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">客胜</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.awayOdds}</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">主队</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.homeOdds}</span>
                    </div>
                    <div className="flex-1 text-center py-1.5 rounded-lg bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <span className="text-xs text-foreground-500">客队</span>
                      <span className="block text-sm font-heading font-semibold text-foreground-800">{event.awayOdds}</span>
                    </div>
                  </>
                )}
              </div>
            </Link>
          ))}
        </div>

        <Link to="/category/football" className="sm:hidden flex items-center justify-center gap-1 mt-6 text-sm text-primary-500 font-medium">
          查看全部赛事 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}